(() => {
  if (window.__sidepillowProductAppPolish) return;
  window.__sidepillowProductAppPolish = true;

  const productSelector = 'product-info.sp-product-page';
  const isEnglish = document.documentElement.lang.toLowerCase().startsWith('en');
  const handlers = new Map([
    ['section-store--comments-block', applyShadowStyle],
    ...(isEnglish ? [
      ['section-store--benefits-boxes-block', applyEnglishBenefitsCopy],
      ['section-store--shipping-info-block', applyEnglishShippingCopy],
    ] : []),
  ]);
  const hostSelector = [...handlers.keys()].join(',');
  const productRoots = new Set();
  const hosts = new Map();
  const queuedContainers = new Set();
  const queuedHosts = new Set();
  const pendingShadowHosts = new Set();
  let frame = null;
  let readinessTimer = null;
  let observing = false;
  const benefitsCopy = new Map([
    ['Achteraf betalen', 'Pay later'],
    ['30 nachten proefslapen', '30-night trial'],
    ['Gratis verzending', '2-year warranty'],
    ['30-night sleep trial', '30-night trial'],
    ['Free shipping', '2-year warranty'],
  ]);
  const styleId = 'sidepillow-comments-mobile-nav-polish';
  const styleText = `
    @media (max-width: 749px) {
      .navigation {
        display: none !important;
      }

      .navigation button {
        display: none !important;
        pointer-events: none !important;
      }
    }
  `;

  function applyShadowStyle(host) {
    if (!host?.shadowRoot || host.shadowRoot.getElementById(styleId)) return;

    const style = document.createElement('style');
    style.id = styleId;
    style.textContent = styleText;
    host.shadowRoot.append(style);
  }

  function applyEnglishBenefitsCopy(host) {
    if (!host?.shadowRoot) return;

    host.shadowRoot.querySelectorAll('.card .title').forEach((title) => {
      const currentCopy = title.textContent.trim();
      const replacementCopy = benefitsCopy.get(currentCopy);
      if (replacementCopy && currentCopy !== replacementCopy) title.textContent = replacementCopy;
    });

  }

  function applyEnglishShippingCopy(host) {
    if (!host?.shadowRoot) return;

    const label = host.shadowRoot.querySelector('.ships-by');
    const timing = host.shadowRoot.querySelector('.shipping-date');

    if (label && label.textContent.trim() !== 'In stock ·') label.textContent = 'In stock ·';
    if (timing && timing.textContent.trim() !== 'Ships within 24 hours') {
      timing.textContent = 'Ships within 24 hours';
    }

  }

  function isProductHost(host) {
    return host.isConnected && productRoots.has(host.closest(productSelector));
  }

  function pruneDisconnected() {
    for (const root of productRoots) {
      if (!root.isConnected) productRoots.delete(root);
    }
    for (const [host, state] of hosts) {
      if (isProductHost(host)) continue;
      state.observer?.disconnect();
      hosts.delete(host);
      queuedHosts.delete(host);
      pendingShadowHosts.delete(host);
    }
    if (!pendingShadowHosts.size && readinessTimer !== null) {
      window.clearTimeout(readinessTimer);
      readinessTimer = null;
    }
  }

  function scheduleFlush() {
    if (frame === null) frame = window.requestAnimationFrame(flush);
  }

  function trackHost(host) {
    if (!isProductHost(host) || hosts.has(host)) return;
    hosts.set(host, { observer: null });
    queuedHosts.add(host);
  }

  function flush() {
    frame = null;
    pruneDisconnected();
    for (const container of queuedContainers) {
      if (!container.isConnected) continue;
      if (handlers.has(container.localName)) trackHost(container);
      container.querySelectorAll(hostSelector).forEach(trackHost);
    }
    queuedContainers.clear();

    for (const host of queuedHosts) {
      const state = hosts.get(host);
      if (!state || !isProductHost(host)) continue;
      if (!host.shadowRoot) {
        pendingShadowHosts.add(host);
        continue;
      }
      pendingShadowHosts.delete(host);
      handlers.get(host.localName)(host);
      if (!state.observer) {
        state.observer = new MutationObserver(() => {
          if (!isProductHost(host)) return;
          queuedHosts.add(host);
          scheduleFlush();
        });
        state.observer.observe(host.shadowRoot, { childList: true, subtree: true, characterData: true });
      }
    }
    queuedHosts.clear();
    scheduleReadinessCheck();
  }

  // attachShadow() is not a light-DOM mutation. Check only known waiting hosts,
  // rather than repeatedly searching the page or giving up on slow app loads.
  function scheduleReadinessCheck() {
    if (!pendingShadowHosts.size || readinessTimer !== null) return;
    readinessTimer = window.setTimeout(() => {
      readinessTimer = null;
      pruneDisconnected();
      for (const host of pendingShadowHosts) {
        if (!host.shadowRoot) continue;
        queuedHosts.add(host);
        pendingShadowHosts.delete(host);
      }
      if (queuedHosts.size) scheduleFlush();
      scheduleReadinessCheck();
    }, 500);
  }

  function addProductRoot(root) {
    if (productRoots.has(root)) return;
    productRoots.add(root);
    queuedContainers.add(root);
    scheduleFlush();
    if (!observing) {
      // Only structural discovery is document-wide, to support Shopify replacing
      // product-info or the whole main. Ordinary app scans stay in added subtrees.
      observer.observe(document.documentElement, { childList: true, subtree: true });
      observing = true;
    }
  }

  function discoverProducts(container) {
    if (container.nodeType === 1 && container.matches(productSelector)) addProductRoot(container);
    container.querySelectorAll(productSelector).forEach(addProductRoot);
  }

  const observer = new MutationObserver((records) => {
    let removedNodes = false;
    for (const record of records) {
      if (record.removedNodes.length) removedNodes = true;
      for (const node of record.addedNodes) {
        if (node.nodeType !== 1) continue;
        const root = node.closest(productSelector);
        if (root) {
          addProductRoot(root);
          queuedContainers.add(node);
          scheduleFlush();
        } else {
          discoverProducts(node);
        }
      }
    }
    if (removedNodes) pruneDisconnected();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => discoverProducts(document), { once: true });
  } else {
    discoverProducts(document);
  }
  document.addEventListener('shopify:section:load', (event) => discoverProducts(event.target));
  document.addEventListener('shopify:section:unload', pruneDisconnected);
})();
